import React from 'react'
import EmailIcon from '@mui/icons-material/Email'
import WhatsAppIcon from '@mui/icons-material/WhatsApp'
import DiscordIcon from '../../../assets/icons/DiscordIcon'
import {
    EscalationChannel,
    EscalationEntity,
    TriggerUnit,
} from '../types/types'

export const ESCALATION_ENTITIES: EscalationEntity[] = ['OIR', 'redmine']

export const ENTITY_LABELS: Record<EscalationEntity, string> = {
    OIR: 'OIR Form',
    redmine: 'Onboarding Redmine Ticket',
}

export const ENTITY_SHORT_LABELS: Record<EscalationEntity, string> = {
    OIR: 'OIR',
    redmine: 'Redmine',
}

export const PREDEFINED_LEVELS = ['I', 'II', 'III', 'IV', 'V', 'VI']

export const TRIGGER_UNITS: { value: TriggerUnit; label: string }[] = [
    { value: 'hours', label: 'Hours' },
    { value: 'days', label: 'Days' },
    { value: 'weeks', label: 'Weeks' },
]

export const CHANNEL_ICONS: Record<EscalationChannel, React.ReactElement> = {
    email: React.createElement(EmailIcon, {
        fontSize: 'small',
        sx: { color: '#ea4335' },
    }),
    whatsapp: React.createElement(WhatsAppIcon, {
        fontSize: 'small',
        sx: { color: '#25d366' },
    }),
    discord: React.createElement(DiscordIcon, {
        fontSize: 'small',
        sx: { color: '#5865f2' },
    }),
}

export const CHANNELS: {
    value: EscalationChannel
    label: string
    icon: React.ReactElement
}[] = [
    { value: 'email', label: 'Email', icon: CHANNEL_ICONS.email },
    { value: 'whatsapp', label: 'WhatsApp', icon: CHANNEL_ICONS.whatsapp },
    { value: 'discord', label: 'Discord', icon: CHANNEL_ICONS.discord },
]

export const entityLabel = (entity: string): string =>
    ENTITY_LABELS[entity as EscalationEntity] ?? entity
